import { render, staticRenderFns } from "./CustomerSummaryReport.vue?vue&type=template&id=2fc68bb9"
import script from "./CustomerSummaryReport.vue?vue&type=script&lang=js"
export * from "./CustomerSummaryReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports